import { v4 as uuidv4 } from "uuid";

import Exercise from "./Exercise";
import Serie from "./Serie";

import ReactDOM from "react-dom";
import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";

class PredefinedExercise {
  constructor(
    id = uuidv4(),
    name = "",
    originalName = "",
    order = 0,
    type = "",
    notes = "",
    link = null,
    isFavorite = false,
    isPopUp = false,
    isSelected = false,
    arms = 0,
    back = 0,
    chest = 0,
    shoulders = 0,
    legs = 0,
    attributes = []
  ) {
    this.id = id;
    this.name = name;
    this.originalName = originalName;
    this.order = order;
    this.type = type;
    this.notes = notes;
    this.link = link;
    this.isFavorite = isFavorite;
    this.isPopUp = isPopUp;
    this.isSelected = isSelected;
    this.arms = arms;
    this.back = back;
    this.chest = chest;
    this.shoulders = shoulders;
    this.legs = legs;
    this.attributes = attributes;
    makeAutoObservable(this);
  }

  duplicate(workout, t) {
    const newOrder =
      workout.exercisesToAdd.length > 0
        ? Math.max(
            ...workout.exercisesToAdd.map((exercise) => exercise.order)
          ) + 1
        : 0;

    const id = uuidv4();

    const newExercise = new Exercise(
      id,
      t(this.name),
      this.originalName,
      "",
      newOrder,
      true,
      false,
      workout,
      [],
      [],
      id.toString(),
      undefined,
      this.link
    );

    for (let i = 0; i < 3; i++) {
      const newSerie = new Serie(
        uuidv4(),
        i,
        0,
        0,
        0,
        undefined,
        undefined,
        undefined,
        newExercise,
        3
      );
      newExercise.series.push(newSerie);
    }

    return newExercise;
  }

  uploadToCloud() {
    return {
      id: this.id.toString(),
      name: this.name,
      notes: this.notes,
      order: this.order,
      original_name: this.originalName,
      type: this.type,
      ...(this.link && this.link != "" ? { link: this.link } : {}),
    };
  }

  setProperty(propertyName, value) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      this[propertyName] = value;
    } else {
      console.error(`Property ${propertyName} does not exist.`);
    }
  }

  static ExerciseTypes = {
    kneeDominant: "kneeDominant-string",
    hipDominant: "hipDominant-string",
    horizontalPush: "horizontalPush-string",
    verticalPush: "verticalPush-string",
    horizontalPull: "horizontalPull-string",
    verticalPull: "verticalPull-string",
    weightlifting: "weightlifting-string",
    other: "other-string",
  };

  /* SEARCH TERM FOR FILTERING */
  searchTerm = "";

  get getSearchTerm() {
    return this.searchTerm;
  }
  static setSearchTerm(w) {
    this.searchTerm = w;
  }
  static getFilteredPredefinedArray() {
    const searchTermLower = this.searchTerm
      ? this.searchTerm.toLowerCase()
      : "";

    return this.searchTerm && this.getPredefinedArray().length > 0
      ? this.getPredefinedArray().filter((pred) => {
          return pred.name.toLowerCase().includes(searchTermLower);
        })
      : this.getPredefinedArray();
  }

  // static getPredefinedArray() {
  //   //KNEE DOMINANT
  //   const squat = new PredefinedExercise(
  //     uuidv4(),
  //     "Sentadilla",
  //     "Sentadilla",
  //     1000,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Coloca los pies a la anchura de los hombros con los dedos ligeramente apuntados hacia afuera. \n\n2. Dobla las rodillas y la cadera, bajando hasta que los muslos estén justo por debajo de la paralela. \n\n3. Empuja el suelo para ponerte de pie, estirando las piernas y la cadera.",
  //     "",
  //     true,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const hackSquat = new PredefinedExercise(
  //     uuidv4(),
  //     "Sentadilla Hack",
  //     "Sentadilla Hack",
  //     1001,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Colócate en la máquina de hack squat con la espalda contra la almohadilla y los hombros bajo las almohadillas de los hombros. \n\n2. Coloca los pies a la anchura de los hombros y desactiva las barras de seguridad. Baja tu cuerpo doblando las rodillas, yendo un poco por debajo de la paralela. \n\n3. Empuja para extender las piernas, regresando a la posición inicial.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const bulgarianSquat = new PredefinedExercise(
  //     uuidv4(),
  //     "Sentadilla Búlgara",
  //     "Sentadilla Búlgara",
  //     1002,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Párate a unos pies de un banco, de espaldas a él, coloca un pie adelantado y el otro encima del banco. \n\n2. Baja tu cuerpo doblando la rodilla delantera, manteniéndola alineada con el pie, hasta que el muslo esté justo por debajo de la paralela. \n\n3. Empuja para volver a la posición inicial. Cambia de pierna y repite.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const staticLunge = new PredefinedExercise(
  //     uuidv4(),
  //     "Lunge Estático",
  //     "Lunge Estático",
  //     1003,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Comienza con una postura escalonada con un pie hacia adelante y el otro pie extendido detrás de ti. \n\n2. Dobla ambas rodillas para bajar tu cuerpo recto hacia abajo, manteniendo la rodilla delantera alineada con el pie, hasta que la rodilla trasera casi toque el suelo. \n\n3. Presiona el pie delantero para volver a la posición inicial. Cambia de pierna y repite.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const frontSquat = new PredefinedExercise(
  //     uuidv4(),
  //     "Sentadilla Frontal",
  //     "Sentadilla Frontal",
  //     1004,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Coloca la barra sobre el frente de tus hombros, cruzando tus brazos para agarrar la barra. \n\n2. Baja tu cuerpo doblando las rodillas y la cadera, manteniendo el pecho erguido, hasta que los muslos estén justo por debajo de la paralela. \n\n3. Empuja para volver a la posición inicial.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const platzSquat = new PredefinedExercise(
  //     uuidv4(),
  //     "Sentadilla Platz",
  //     "Sentadilla Platz",
  //     1005,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Coloca los pies más anchos que la anchura de los hombros y angula los dedos de los pies hacia afuera. \n\n2. Bájate doblando las rodillas y la cadera, manteniendo la espalda recta, hasta que los muslos estén justo por debajo de la paralela. \n\n3. Empuja para volver a la posición inicial.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const zercherSquat = new PredefinedExercise(
  //     uuidv4(),
  //     "Sentadilla Zercher",
  //     "Sentadilla Zercher",
  //     1006,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Sostén una barra en el pliegue de tus codos, con los pies a la anchura de los hombros. \n\n2. Dobla tus rodillas y caderas, bajando tu cuerpo hasta que los muslos estén justo por debajo de la paralela. \n\n3. Empuja para ponerte de pie, estirando las piernas y la cadera.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const legCurls = new PredefinedExercise(
  //     uuidv4(),
  //     "Curl de Piernas",
  //     "Curl de Piernas",
  //     1007,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Acuéstate boca abajo en una máquina de curl de piernas, posicionando la palanca acolchada debajo de tus pantorrillas. \n\n2. Flexionando los isquiotibiales, trayendo los talones hacia tus glúteos. \n\n3. Baja lentamente el los pies a la posición inicial, manteniendo el control durante todo el movimiento.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const legExtension = new PredefinedExercise(
  //     uuidv4(),
  //     "Extensión de Piernas",
  //     "Extensión de Piernas",
  //     1008,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Siéntate en una máquina de extensión de piernas con la espalda contra la almohadilla y coloca tus espinillas debajo de la palanca acolchada. \n\n2. Extiende tus piernas flexionando los cuádriceps, levantando el peso. \n\n3. Regresa lentamente a la posición inicial, controlando el movimiento.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const legPress = new PredefinedExercise(
  //     uuidv4(),
  //     "Prensa de Piernas",
  //     "Prensa de Piernas",
  //     1009,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Siéntate en una máquina de prensa de piernas con los pies a la anchura de los hombros en la plataforma. \n\n2. Baja el peso doblando tus rodillas, manteniéndolas alineadas con tus pies, hasta que los muslos estén justo por debajo de paralelos al suelo. \n\n3. Empuja para volver a la posición inicial.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const zancadas = new PredefinedExercise(
  //     uuidv4(),
  //     "Zancadas",
  //     "Zancadas",
  //     1011,
  //     this.ExerciseTypes.kneeDominant,
  //     "1. Párate con los pies separados a la anchura de las caderas y da un paso adelante con una pierna. \n\n2. Baja tu cuerpo doblando ambas rodillas hasta que la rodilla trasera casi toque el suelo, manteniendo la rodilla delantera alineada con el pie. \n\n3. Empuja para volver a la posición inicial, luego cambia de pierna y repite.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );

  //   //HIP DOMINANT
  //   const conventionalDeadlift = new PredefinedExercise(
  //     uuidv4(),
  //     "Peso Muerto Convencional",
  //     "Peso Muerto Convencional",
  //     1100,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Párate con los pies separados a la anchura de la cadera y agarra la barra con las manos justo fuera de las rodillas. \n\n2. Manteniendo la espalda recta, empuja para levantar la barra, extendiendo completamente tu cadera y rodillas. \n\n3. Baja la barra al suelo.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const sumoDeadlift = new PredefinedExercise(
  //     uuidv4(),
  //     "Peso Muerto Sumo",
  //     "Peso Muerto Sumo",
  //     1101,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Párate con los pies más anchos que la anchura de los hombros, los dedos de los pies apuntando hacia afuera, y agarra la barra dentro de tus rodillas. \n\n2. Manteniendo la espalda recta, empuja para levantar la barra, extendiendo completamente tu cadera y rodillas. \n\n3. Baja la barra al suelo, manteniendo el control durante todo el movimiento.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const romanianDeadlift = new PredefinedExercise(
  //     uuidv4(),
  //     "Peso Muerto Rumano",
  //     "Peso Muerto Rumano",
  //     1102,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Párate con los pies separados a la anchura de las caderas, sosteniendo una barra con un agarre mixto. \n\n2. Manteniendo las piernas ligeramente dobladas, inclínate en las caderas para bajar la barra hacia el suelo, manteniéndola cerca de tus piernas. \n\n3. Invierte el movimiento, impulsando a través de las caderas para volver a la posición inicial.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const oneLegDeadlift = new PredefinedExercise(
  //     uuidv4(),
  //     "Peso Muerto a una Pierna",
  //     "Peso Muerto a una Pierna",
  //     1103,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Párate sobre una pierna, sosteniendo un peso con la mano opuesta. \n\n2. Inclínate en la cadera de la pierna que está parada, bajando el peso hacia el suelo y extendiendo la otra pierna detrás de ti. \n\n3. Regresa a la posición inicial, manteniendo tu equilibrio, y cambia de lado.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const stiffLegDeadlift = new PredefinedExercise(
  //     uuidv4(),
  //     "Peso Muerto Piernas Rectas",
  //     "Peso Muerto Piernas Rectas",
  //     1104,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Párate con los pies a la anchura de los hombros, sosteniendo una barra delante de ti. \n\n2. Manteniendo las piernas rectas, inclínate en las caderas para bajar la barra hacia el suelo. \n\n3. Regresa a la posición inicial activando los glúteos y los isquiotibiales.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const goodMorning = new PredefinedExercise(
  //     uuidv4(),
  //     "Buenos Días",
  //     "Buenos Días",
  //     1105,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Coloca una barra sobre la parte superior de tu espalda, con los pies a la anchura de los hombros. \n\n2. Inclínate en las caderas, bajando tu torso hacia el suelo, manteniendo las piernas rectas y la espalda plana. \n\n3. Vuelve a la posición inicial impulsando a través de las caderas.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const hipThrust = new PredefinedExercise(
  //     uuidv4(),
  //     "Hip Thrust",
  //     "Hip Thrust",
  //     1106,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Siéntate en el suelo con una barra sobre tu cadera y los hombros contra un banco. \n\n2. Empuja levantando tu cadera hacia el techo, apretando los glúteos en la parte superior. \n\n3. Baja las caderas de nuevo al suelo, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const elevacionGluteo = new PredefinedExercise(
  //     uuidv4(),
  //     "Elevación Glúteo-Femoral",
  //     "Elevación Glúteo-Femoral",
  //     1107,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Posiciónate en una máquina de GHR con los pies asegurados y las rodillas justo detrás de la almohadilla. \n\n2. Baja tu cuerpo extendiendo las rodillas, manteniendo una línea recta desde la cabeza hasta las rodillas. \n\n3. Vuelve a la posición inicial flexionando los isquiotibiales y los glúteos.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const abductorMachine = new PredefinedExercise(
  //     uuidv4(),
  //     "Máquina de Abductor",
  //     "Máquina de Abductor",
  //     1108,
  //     this.ExerciseTypes.hipDominant,
  //     "1. Siéntate en la máquina de abducción con las piernas dentro de las almohadillas. \n\n2. Presiona contra las almohadillas, separando las piernas. \n\n3. Regresa lentamente a la posición inicial, manteniendo el control durante todo el movimiento.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );

  //   //HORIZONTAL PUSH
  //   const benchPress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press Banca",
  //     "Press Banca",
  //     1200,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Acuéstate plano en un banco con los pies apoyados en el suelo, agarrando la barra sobre ti. \n\n2. Baja la barra hacia tu pecho, manteniendo los codos en un ángulo de 45 grados. \n\n3. Presiona la barra de vuelta a la posición inicial, extendiendo completamente tus brazos.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const inclineBenchPress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press Banca Inclinado",
  //     "Press Banca Inclinado",
  //     1201,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Acuéstate en un banco inclinado con los pies apoyados en el suelo, agarrando la barra sobre ti. \n\n2. Baja la barra hacia tu pecho superior, manteniendo los codos en un ángulo de 45 grados. \n\n3. Presiona la barra de vuelta a la posición inicial, extendiendo completamente tus brazos.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const declineBenchPress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press Banca Declinado",
  //     "Press Banca Declinado",
  //     1202,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Acuéstate en un banco declinado con los pies asegurados, agarrando la barra sobre ti. \n\n2. Baja la barra hacia tu pecho inferior, manteniendo los codos en un ángulo de 45 grados. \n\n3. Presiona la barra de vuelta a la posición inicial, extendiendo completamente tus brazos.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const machinePress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press en Máquina",
  //     "Press en Máquina",
  //     1203,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Siéntate en la máquina de press de pecho de forma que los codos estén a 45 grados respecto tu torso. \n\n2. Empuja la máquina para extender los codos por completo. \n\n3. Regresa a la posición inicial de forma controlada.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const floorPress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press de Suelo",
  //     "Press de Suelo",
  //     1204,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Acuéstate en el suelo con las rodillas dobladas, agarrando una barra sobre tu pecho. \n\n2. Baja la barra hacia el suelo, hasta que tus codos toquen el suelo. \n\n3. Presiona la barra de vuelta a la posición inicial, extendiendo completamente tus brazos.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const jmPress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press JM",
  //     "Press JM",
  //     1205,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Acuéstate en un banco plano, sosteniendo una barra sobre tu pecho con los brazos extendidos. \n\n2. Baja la barra hacia tu pecho superior, pero detente a medio camino abriendo los codos hacia afuera. \n\n3. Extiende tus brazos para volver a la posición inicial, enfocándote en la activación del tríceps.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const inclinePushUps = new PredefinedExercise(
  //     uuidv4(),
  //     "Flexiones en Banco Inclinado",
  //     "Flexiones en Banco Inclinado",
  //     1206,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Coloca las manos en una superficie elevada, como un banco, con los pies en el suelo. \n\n2. Baja tu pecho hacia la superficie doblando los codos. \n\n3. Presiona a través de tus palmas para volver a la posición inicial, extendiendo completamente tus brazos.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const pushUps = new PredefinedExercise(
  //     uuidv4(),
  //     "Flexiones",
  //     "Flexiones",
  //     1207,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Comienza en una posición de plancha con las manos debajo de los hombros y el cuerpo recto. \n\n2. Baja tu pecho hacia el suelo doblando los codos. \n\n3. Presiona a través de tus palmas para volver a la posición inicial, extendiendo completamente tus brazos.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const tricepExtensions = new PredefinedExercise(
  //     uuidv4(),
  //     "Extensiones de Tríceps",
  //     "Extensiones de Tríceps",
  //     1208,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Sostén una mancuerna con ambas manos sobre tu cabeza con los brazos extendidos. \n\n2. Dobla tus codos para bajar el peso detrás de tu cabeza, manteniendo los codos cerca uno del otro. \n\n3. Extiende tus brazos para volver a la posición inicial.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const tricepsPushdown = new PredefinedExercise(
  //     uuidv4(),
  //     "Empuje de Tríceps",
  //     "Empuje de Tríceps",
  //     1209,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Párate en una polea, agarrando la manija con las palmas hacia abajo. \n\n2. Empuja la manija hacia abajo extendiendo tus codos, manteniendo tus brazos superiores inmóviles. \n\n3. Regresa lentamente a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const flies = new PredefinedExercise(
  //     uuidv4(),
  //     "Aperturas",
  //     "Aperturas",
  //     1210,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Acuéstate en un banco con una mancuerna en cada mano, brazos extendidos sobre ti. \n\n2. Con un ligero doblez en los codos, baja los pesos hacia los lados. \n\n3. Junta los pesos nuevamente sobre tu pecho, apretando los pectorales.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const skullCrushers = new PredefinedExercise(
  //     uuidv4(),
  //     "Skull Crushers",
  //     "Skull Crushers",
  //     1211,
  //     this.ExerciseTypes.horizontalPush,
  //     "1. Acuéstate en un banco, sosteniendo una barra sobre tu cabeza con los brazos extendidos. \n\n2. Dobla tus codos para bajar la barra hacia tu frente, manteniendo los brazos superiores inmóviles. \n\n3. Extiende tus brazos para volver a la posición inicial.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );

  //   //VERTICAL PUSH
  //   const militarPress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press Militar",
  //     "Press Militar",
  //     1300,
  //     this.ExerciseTypes.verticalPush,
  //     "1. Párate con una barra a nivel del pecho, agarrándola con las manos a la anchura de los hombros. \n\n2. Presiona la barra por encima de la cabeza, extendiendo completamente tus brazos. \n\n3. Baja la barra a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const dips = new PredefinedExercise(
  //     uuidv4(),
  //     "Fondos",
  //     "Fondos",
  //     1301,
  //     this.ExerciseTypes.verticalPush,
  //     "1. Agarra las barras paralelas, sosteniéndote con los brazos completamente extendidos. \n\n2. Baja tu cuerpo doblando los codos, manteniéndolos cerca de tus costados. \n\n3. Empuja para volver a la posición inicial.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const flexionesDePino = new PredefinedExercise(
  //     uuidv4(),
  //     "Flexiones en Pino",
  //     "Flexiones en Pino",
  //     1302,
  //     this.ExerciseTypes.verticalPush,
  //     "1. Haz un pino contra una pared, con los brazos completamente extendidos. \n\n2. Baja tu cuerpo hacia el suelo doblando los codos. \n\n3. Presiona a través de tus palmas para volver a la posición inicial, extendiendo completamente tus brazos.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const landminePress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press Landmine",
  //     "Press Landmine",
  //     1303,
  //     this.ExerciseTypes.verticalPush,
  //     "1. Párate sosteniendo el extremo de una barra asegurada en un soporte de landmine, a la altura del hombro. \n\n2. Presiona la barra hacia arriba, extendiendo completamente tu brazo. \n\n3. Baja la barra a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );

  //   //HORIZONTAL PULL
  //   const cableRow = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo con Polea",
  //     "Remo con Polea",
  //     1400,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Siéntate en una máquina de remo con cable, agarrando las manijas con los pies en la plataforma. \n\n2. Tira de las manijas hacia tu torso, apretando los omóplatos juntos. \n\n3. Extiende tus brazos para volver a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const tRow = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo en T",
  //     "Remo en T",
  //     1401,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Párate sobre una máquina de remo T-Bar, agarrando las manijas con una postura inclinada hacia adelante. \n\n2. Jala el peso hacia tus costillas inferiores, manteniendo los codos cerca de tu cuerpo. \n\n3. Baja el peso a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const inclineBenchRow = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo en Banco Inclinado",
  //     "Remo en Banco Inclinado",
  //     1402,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Acuéstate boca abajo en un banco con una ligera inclinación, sosteniendo mancuernas debajo de ti. \n\n2. Tira de los pesos hacia tu cadera, apretando los omóplatos juntos. \n\n3. Baja los pesos a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const pendlayRow = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo Pendlay",
  //     "Remo Pendlay",
  //     1403,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Párate sobre una barra con una postura inclinada hacia adelante, agarrándola con las manos a la anchura de los hombros. \n\n2. Jala explosivamente la barra hacia tus costillas inferiores, manteniendo tu torso paralelo al suelo. \n\n3. Baja la barra a la posición inicial con control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const inclineRow = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo Inclinado",
  //     "Remo Inclinado",
  //     1404,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Acuéstate boca abajo en un banco inclinado, sosteniendo mancuernas debajo de ti. \n\n2. Tira de los pesos hacia tu cadera, apretando los omóplatos juntos. \n\n3. Baja los pesos a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const oneArmRow = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo a una Mano",
  //     "Remo a una Mano",
  //     1405,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Párate al lado de un banco, con una rodilla y una mano sobre él, sosteniendo una mancuerna con la otra mano. \n\n2. Tira de la mancuerna hacia tu cadera, manteniendo tu codo cerca de tu cuerpo. \n\n3. Baja la mancuerna a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const row = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo",
  //     "Remo",
  //     1406,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Sostén una barra o mancuernas con una postura inclinada hacia adelante, las manos a la anchura de los hombros. \n\n2. Tira del peso hacia tus costillas inferiores, apretando los omóplatos juntos. \n\n3. Baja el peso a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const facePull = new PredefinedExercise(
  //     uuidv4(),
  //     "Face Pull",
  //     "Face Pull",
  //     1407,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Párate en una máquina de cables con un accesorio de cuerda, agarrando los extremos. \n\n2. Tira de la cuerda hacia tu cara, manteniendo los codos altos. \n\n3. Extiende tus brazos para volver a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const reverseRow = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo Invertido con Peso Corporal",
  //     "Remo Invertido con Peso Corporal",
  //     1408,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Posiciónate debajo de una barra o anillos, agarrándolos con los brazos extendidos. \n\n2. Tira de tu pecho hacia la barra, apretando los omóplatos juntos. \n\n3. Bájate a la posición inicial con control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const pajaros = new PredefinedExercise(
  //     uuidv4(),
  //     "Pájaros",
  //     "Pájaros",
  //     1409,
  //     this.ExerciseTypes.horizontalPull,
  //     "1. Posiciónate debajo de una barra o anillos, agarrándolos con los brazos extendidos. \n\n2. Tira de tu pecho hacia la barra, apretando los omóplatos juntos. \n\n3. Bájate a la posición inicial con control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );

  //   //VERTICAL PULL
  //   const pullUps = new PredefinedExercise(
  //     uuidv4(),
  //     "Dominadas",
  //     "Dominadas",
  //     1500,
  //     this.ExerciseTypes.verticalPull,
  //     "1. Agarra una barra de dominadas con las manos separadas a la anchura de los hombros, las palmas mirando hacia afuera. \n\n2. Elévate hasta que tu barbilla esté por encima de la barra. \n\n3. Bájate a la posición inicial con control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const pullDown = new PredefinedExercise(
  //     uuidv4(),
  //     "Jalón al Pecho",
  //     "Jalón al Pecho",
  //     1501,
  //     this.ExerciseTypes.verticalPull,
  //     "1. Siéntate en una máquina de polea al pecho, agarrando la barra con las manos más separadas que los hombros. \n\n2. Tira de la barra hacia tu pecho superior, apretando los omóplatos. \n\n3. Extiende tus brazos para volver a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const pullOver = new PredefinedExercise(
  //     uuidv4(),
  //     "Pullover",
  //     "Pullover",
  //     1502,
  //     this.ExerciseTypes.verticalPull,
  //     "1. Acuéstate en un banco, sosteniendo una mancuerna con ambas manos sobre tu pecho. \n\n2. Baja el peso detrás de tu cabeza, manteniendo tus brazos ligeramente doblados. \n\n3. Trae el peso de vuelta a la posición inicial, utilizando tus dorsales.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const verticalRow = new PredefinedExercise(
  //     uuidv4(),
  //     "Remo Vertical",
  //     "Remo Vertical",
  //     1503,
  //     this.ExerciseTypes.verticalPull,
  //     "1. Párate sosteniendo una barra o mancuernas a la altura del muslo, con las manos juntas. \n\n2. Tira del peso hacia tu pecho superior. \n\n3. Baja el peso a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );

  //   //OTHER
  //   const curls = new PredefinedExercise(
  //     uuidv4(),
  //     "Curl de Bíceps",
  //     "Curl de Bíceps",
  //     1600,
  //     this.ExerciseTypes.other,
  //     "1. Párate sosteniendo mancuernas a tus costados, con las palmas mirando hacia adelante. \n\n2. Levanta los pesos hacia tus hombros, manteniendo los codos cerca de tu cuerpo. \n\n3. Baja los pesos a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const inclineCurls = new PredefinedExercise(
  //     uuidv4(),
  //     "Curl de Bíceps Inclinado",
  //     "Curl de Bíceps Inclinado",
  //     1601,
  //     this.ExerciseTypes.other,
  //     "1. Siéntate en un banco inclinado, sosteniendo mancuernas a tus costados. \n\n2. Levanta los pesos hacia tus hombros, manteniendo los codos cerca de tu cuerpo. \n\n3. Baja los pesos a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const hammerCurls = new PredefinedExercise(
  //     uuidv4(),
  //     "Curl de Bíceps Martillo",
  //     "Curl de Bíceps Martillo",
  //     1602,
  //     this.ExerciseTypes.other,
  //     "1. Párate sosteniendo mancuernas a tus costados, con las palmas mirando una hacia la otra. \n\n2. Levanta los pesos hacia tus hombros, manteniendo los codos cerca de tu cuerpo. \n\n3. Baja los pesos a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const lateralRaise = new PredefinedExercise(
  //     uuidv4(),
  //     "Elevación Lateral",
  //     "Elevación Lateral",
  //     1603,
  //     this.ExerciseTypes.other,
  //     "1. Párate sosteniendo mancuernas a tus costados, con las palmas mirando hacia adentro. \n\n2. Eleva los pesos hacia los lados, manteniendo los brazos ligeramente doblados. \n\n3. Baja los pesos a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const frontRaise = new PredefinedExercise(
  //     uuidv4(),
  //     "Elevación Frontal",
  //     "Elevación Frontal",
  //     1604,
  //     this.ExerciseTypes.other,
  //     "1. Párate sosteniendo mancuernas a tus costados, con las palmas mirando hacia adentro. \n\n2. Eleva los pesos frente a ti, manteniendo los brazos ligeramente doblados. \n\n3. Baja los pesos a la posición inicial, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const absWheel = new PredefinedExercise(
  //     uuidv4(),
  //     "Rueda Abdominal",
  //     "Rueda Abdominal",
  //     1605,
  //     this.ExerciseTypes.other,
  //     "1. Arrodíllate en el suelo, sosteniendo una rueda abdominal con ambas manos. \n\n2. Haz rodar la rueda hacia adelante, extendiendo tu cuerpo en una línea recta. \n\n3. Vuelve la rueda a la posición inicial, activando tu core.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const copenhaguenPlank = new PredefinedExercise(
  //     uuidv4(),
  //     "Plancha Copenhague",
  //     "Plancha Copenhague",
  //     1606,
  //     this.ExerciseTypes.other,
  //     "1. Posiciónate en una plancha lateral, apoyándote en un antebrazo con la pierna superior en un banco. \n\n2. Mantén tu cuerpo en línea recta, activando tu core y el muslo interno. \n\n3. Mantén la posición durante el tiempo deseado.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const lateralPlank = new PredefinedExercise(
  //     uuidv4(),
  //     "Plancha Lateral",
  //     "Plancha Lateral",
  //     1607,
  //     this.ExerciseTypes.other,
  //     "1. Acuéstate de lado, apoyándote en un antebrazo con las piernas estiradas. \n\n2. Levanta tu cadera del suelo, formando una línea recta desde la cabeza hasta los talones. \n\n3. Mantén la posición, activando tu core, durante el tiempo deseado.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const floorBar = new PredefinedExercise(
  //     uuidv4(),
  //     "Rotación con Barra en el Suelo",
  //     "Rotación con Barra en el Suelo",
  //     1608,
  //     this.ExerciseTypes.other,
  //     "1. Párate sosteniendo el extremo de una barra asegurada en un soporte de landmine, a la altura del pecho. \n\n2. Rota tu torso, moviendo la barra de un lado a otro. \n\n3. Repite el movimiento, manteniendo el control y activando tu core.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const toeRaise = new PredefinedExercise(
  //     uuidv4(),
  //     "Elevación de Talones",
  //     "Elevación de Talones",
  //     1609,
  //     this.ExerciseTypes.other,
  //     "1. Párate derecho, con los pies separados a la anchura de las caderas. \n\n2. Elevate sobre tus dedos de los pies, activando los músculos de las pantorrillas. \n\n3. Baja los talones al suelo, manteniendo el control.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const legRaise = new PredefinedExercise(
  //     uuidv4(),
  //     "Elevación de Piernas",
  //     "Elevación de Piernas",
  //     1610,
  //     this.ExerciseTypes.other,
  //     "1. Acuéstate de espaldas, con las piernas extendidas hacia arriba. \n\n2. Baja tus piernas hacia el suelo, manteniéndolas rectas. \n\n3. Levántalas de nuevo a la posición inicial, activando tu core.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );
  //   const pallofPress = new PredefinedExercise(
  //     uuidv4(),
  //     "Press Pallof",
  //     "Press Pallof",
  //     1611,
  //     this.ExerciseTypes.other,
  //     "1. Párate de lado a una máquina de cables, agarrando la manija a la altura del pecho. \n\n2. Presiona la manija directamente frente a ti, resistiendo la rotación. \n\n3. Vuelve a la posición inicial, manteniendo el control y la alineación.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );

  //   //HALTEROFILIA
  //   const cleanPull = new PredefinedExercise(
  //     uuidv4(),
  //     "Clean Pull",
  //     "Clean Pull",
  //     1700,
  //     this.ExerciseTypes.weightlifting,
  //     "1. Párate sobre una barra, agarrándola con las manos más separadas que el ancho de los hombros. \n\n2. Extiende de manera explosiva tu cadera y rodillas, tirando de la barra hacia arriba. \n\n3. Devuelve la barra al suelo con control, manteniendo una forma adecuada.",
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     undefined,
  //     []
  //   );

  //   return [
  //     squat,
  //     hackSquat,
  //     bulgarianSquat,
  //     staticLunge,
  //     frontSquat,
  //     platzSquat,
  //     zercherSquat,
  //     legCurls,
  //     legExtension,
  //     legPress,
  //     zancadas,
  //     conventionalDeadlift,
  //     sumoDeadlift,
  //     romanianDeadlift,
  //     oneLegDeadlift,
  //     stiffLegDeadlift,
  //     goodMorning,
  //     hipThrust,
  //     elevacionGluteo,
  //     abductorMachine,
  //     benchPress,
  //     inclineBenchPress,
  //     declineBenchPress,
  //     machinePress,
  //     floorPress,
  //     jmPress,
  //     inclinePushUps,
  //     pushUps,
  //     tricepExtensions,
  //     tricepsPushdown,
  //     flies,
  //     skullCrushers,
  //     militarPress,
  //     dips,
  //     flexionesDePino,
  //     landminePress,
  //     cableRow,
  //     tRow,
  //     inclineBenchRow,
  //     pendlayRow,
  //     inclineRow,
  //     oneArmRow,
  //     row,
  //     facePull,
  //     reverseRow,
  //     pajaros,
  //     pullUps,
  //     pullDown,
  //     pullOver,
  //     verticalRow,
  //     curls,
  //     inclineCurls,
  //     hammerCurls,
  //     lateralRaise,
  //     frontRaise,
  //     absWheel,
  //     copenhaguenPlank,
  //     lateralPlank,
  //     floorBar,
  //     toeRaise,
  //     legRaise,
  //     pallofPress,
  //     cleanPull,
  //   ];
  // }
}
export default PredefinedExercise;
